import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import LoginPage from "./page/login/LoginPage";
import CalibrationLog from "./page/CalibrationLog/CalibrationLog";
import CalibrationLoglistPage from "./page/CalibrationLog/CalibrationLoglist";
import Dashboard from "./page/dashboard/Dashboard";
import AssetregisterPageList from "./page/AssetRegister/Assetregisterpagelist";
import DatabaseKeyPage from "./page/login/DatabaseKeyPage";
import AssetRegister from "./page/AssetRegister/Assetregister";
import AssetMovementList from "./page/AssetMovement/AssetMovementList";
import AssetMovement from "./page/AssetMovement/AssetMovement"; // ✅ form page
import TicketList from "./page/Ticket/TicketList"; 
import TicketForm from "./page/Ticket/TicketForm";
import "./App.css";
import ServiceList from "./page/Service/ServiceList"; 
import ServiceForm from "./page/Service/ServiceForm";
import TicketSummary from "./page/Report/TicketSummary"; 


function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("isLoggedIn") === "true"
  );

  // ✅ Check login status whenever location changes
  useEffect(() => {
    const storedLogin = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(storedLogin);
  }, [location]);

  const menuItems = [
    { name: "Dashboard", path: "/dashboard" },
    { name: "Asset", path: "/AssetregisterPageList" },
    { name: "Calibration", path: "/CalibrationLoglistPage" },
    { name: "Asset Movement", path: "/AssetMovementList" },
    { name: "Ticket", path: "/TicketList" },
    { name: "Service", path: "/ServiceList" },
    { name: "Ticket Summary", path: "/TicketSummary" },
    { name: "Logout", path: "/DatabaseKeyPage" },
  ];

  const handleMenuClick = () => setMenuOpen((prev) => !prev);

  const handleNavigate = (path, name) => {
    setMenuOpen(false);

    // ✅ Handle Logout logic
    if (name === "Logout") {
      sessionStorage.clear(); // ✅ Clear all session data
      localStorage.removeItem("isLoggedIn"); // ✅ Clear login state
      setIsLoggedIn(false);
      console.log("Session and login cleared!");
      navigate("/DatabaseKeyPage");
      return;
    }

    // ✅ Navigate normally
    navigate(path);
  };

  return (
    <div className="app-container">
      {/* ✅ Menu icon only when logged in and not on login or database key page */}
      {isLoggedIn &&
        location.pathname !== "/login" &&
        location.pathname !== "/" && (
          <div className="menu-container">
            <div className="menu-icon" onClick={handleMenuClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="40"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" y1="6" x2="20" y2="6" />
                <line x1="4" y1="12" x2="20" y2="12" />
                <line x1="4" y1="18" x2="20" y2="18" />
              </svg>
            </div>

            {menuOpen && (
              <div className="menu-dropdown">
                {menuItems.map((item, index) => (
                  <button
                    key={item.path}
                    onClick={() => handleNavigate(item.path, item.name)}
                    className="menu-item"
                    style={{
                      animation: `fadeIn 0.3s ease forwards`,
                      animationDelay: `${index * 0.15}s`,
                      opacity: 0,
                    }}
                  >
                    {item.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

      <Routes>
        {/* ✅ Default page */}
        <Route path="/" element={<DatabaseKeyPage />} />

        {/* ✅ Login page */}
        <Route
          path="/login"
          element={
            <LoginPage
              onLoginSuccess={() => {
                localStorage.setItem("isLoggedIn", "true");
                setIsLoggedIn(true);
              }}
            />
          }
        />

        {/* ✅ Other pages */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/CalibrationLog" element={<CalibrationLog />} />
        <Route
          path="/CalibrationLoglistPage"
          element={<CalibrationLoglistPage />}
        />
        <Route
          path="/AssetregisterPageList"
          element={<AssetregisterPageList />}
        />
        <Route path="/AssetRegister" element={<AssetRegister />} />
        <Route path="/DatabaseKeyPage" element={<DatabaseKeyPage />} />


                <Route
          path="/AssetMovementList"
          element={<AssetMovementList />}
        />
       
        <Route path="/movement/new" element={<AssetMovement />} />
       
        <Route path="/movement/edit/:id" element={<AssetMovement />} />
       
      <Route
          path="/TicketList"
          element={<TicketList />}
        />
<Route path="/TicketForm" element={<TicketForm />} />            
<Route path="/TicketForm/:ticketId" element={<TicketForm />} />  

  <Route
          path="/ServiceList"
          element={<ServiceList />}
        />
        <Route path="/ServiceForm" element={<ServiceForm />} />
<Route path="/ServiceForm/:id" element={<ServiceForm />} />

<Route path="/TicketSummary" element={<TicketSummary />} />


      </Routes>
    </div>
  );
}

export default App;


// import React, { useState, useEffect } from "react";
// import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
// import LoginPage from "./page/login/LoginPage";
// import CalibrationLog from "./page/CalibrationLog/CalibrationLog";
// import CalibrationLoglistPage from "./page/CalibrationLog/CalibrationLoglist";
// import Dashboard from "./page/dashboard/Dashboard";
// import AssetregisterPageList from "./page/AssetRegister/Assetregisterpagelist";
// import DatabaseKeyPage from "./page/login/DatabaseKeyPage";
// import AssetRegister from "./page/AssetRegister/Assetregister";
// import "./App.css";

// function App() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     localStorage.getItem("isLoggedIn") === "true"
//   );

//   // ✅ Check login status whenever location changes
//   useEffect(() => {
//     const storedLogin = localStorage.getItem("isLoggedIn") === "true";
//     setIsLoggedIn(storedLogin);
//   }, [location]);

//   const menuItems = [
//     { name: "Dashboard", path: "/dashboard" },
//     { name: "Calibration", path: "/CalibrationLoglistPage" },
//     { name: "Asset", path: "/AssetregisterPageList" },
//     { name: "Logout", path: "/DatabaseKeyPage" },
//   ];

//   const handleMenuClick = () => setMenuOpen((prev) => !prev);

//   const handleNavigate = (path) => {
//     setMenuOpen(false);
//     if (path === "/login") {
//       localStorage.removeItem("isLoggedIn");
//       setIsLoggedIn(false);
//       navigate("/login");
//       return;
//     }
//     navigate(path);
//   };

//   return (
//     <div className="app-container">
//       {/* ✅ Menu icon only when logged in and not on login or database key page */}
//       {isLoggedIn &&
//         location.pathname !== "/login" &&
//         location.pathname !== "/" && (
//           <div className="menu-container">
//             <div className="menu-icon" onClick={handleMenuClick}>
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="30"
//                 height="40"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="black"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <line x1="4" y1="6" x2="20" y2="6" />
//                 <line x1="4" y1="12" x2="20" y2="12" />
//                 <line x1="4" y1="18" x2="20" y2="18" />
//               </svg>
//             </div>

//             {menuOpen && (
//               <div className="menu-dropdown">
//                 {menuItems.map((item, index) => (
//                   <button
//                     key={item.path}
//                     onClick={() => handleNavigate(item.path)}
//                     className="menu-item"
//                     style={{
//                       animation: `fadeIn 0.3s ease forwards`,
//                       animationDelay: `${index * 0.15}s`,
//                       opacity: 0,
//                     }}
//                   >
//                     {item.name}
//                   </button>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}

//       <Routes>
//         {/* ✅ Database key page is now the first page */}
//         <Route path="/" element={<DatabaseKeyPage />} />

//         {/* ✅ Login page remains accessible */}
//         <Route
//           path="/login"
//           element={
//             <LoginPage
//               onLoginSuccess={() => {
//                 localStorage.setItem("isLoggedIn", "true");
//                 setIsLoggedIn(true);
//               }}
//             />
//           }
//         />

//         {/* ✅ Other existing pages */}
        
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/CalibrationLog" element={<CalibrationLog />} />
//         <Route
//           path="/CalibrationLoglistPage"
//           element={<CalibrationLoglistPage />}
//         />
//         <Route
//           path="/AssetregisterPageList"
//           element={<AssetregisterPageList />}
//         />
//               <Route
//           path="/AssetRegister"
//           element={<AssetRegister />}
//         />

//                   <Route
//           path="/DatabaseKeyPage"
//           element={<DatabaseKeyPage />}
//         />
        
//       </Routes>

      
//     </div>
//   );
// }

// export default App;



// import React, { useState, useEffect } from "react";
// import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
// import LoginPage from "./page/login/LoginPage";
// import CalibrationLog from "./page/CalibrationLog/CalibrationLog";
// import CalibrationLoglistPage from "./page/CalibrationLog/CalibrationLoglist";
// import Dashboard from "./page/dashboard/Dashboard";
// import AssetregisterPageList from "./page/AssetRegister/Assetregisterpagelist";
// import DatabaseKeyPage from "./page/login/DatabaseKeyPage";
// import "./App.css";

// function App() {
//   const navigate = useNavigate();
//   const location = useLocation();
 
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     localStorage.getItem("isLoggedIn") === "true"
//   );

//   // ✅ Check login status whenever location changes
//   useEffect(() => {
//     const storedLogin = localStorage.getItem("isLoggedIn") === "true";
//     setIsLoggedIn(storedLogin);
//   }, [location]);

//   const menuItems = [
//     { name: "Dashboard", path: "/dashboard" },
//     { name: "Calibration", path: "/CalibrationLoglistPage" },
//     { name: "AssetRegister", path: "/AssetregisterPageList" },
//     { name: "Logout", path: "/" },
//   ];

//   const handleMenuClick = () => setMenuOpen((prev) => !prev);

//   const handleNavigate = (path) => {
//     setMenuOpen(false);
//     if (path === "/") {
//       localStorage.removeItem("isLoggedIn");
//       setIsLoggedIn(false);
//       navigate("/");
//       return;
//     }
//     navigate(path);
//   };

//   return (
//     <div className="app-container">
//       {/* ✅ Menu icon only when logged in and not on login page */}
//       {isLoggedIn && location.pathname !== "/" && (
//         <div className="menu-container">
//           <div className="menu-icon" onClick={handleMenuClick}>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="30"
//               height="40"
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="black"
//               strokeWidth="2"
//               strokeLinecap="round"
//               strokeLinejoin="round"
//             >
//               <line x1="4" y1="6" x2="20" y2="6" />
//               <line x1="4" y1="12" x2="20" y2="12" />
//               <line x1="4" y1="18" x2="20" y2="18" />
//             </svg>
//           </div>

//           {menuOpen && (
//             <div className="menu-dropdown">
//               {menuItems.map((item, index) => (
//                 <button
//                   key={item.path}
//                   onClick={() => handleNavigate(item.path)}
//                   className="menu-item"
//                   style={{
//                     animation: `fadeIn 0.3s ease forwards`,
//                     animationDelay: `${index * 0.15}s`,
//                     opacity: 0,
//                   }}
//                 >
//                   {item.name}
//                 </button>
//               ))}
//             </div>
//           )}
//         </div>
//       )}

//       <Routes>
//         <Route
//           path="/"
//           element={
//             <LoginPage
//               onLoginSuccess={() => {
//                 localStorage.setItem("isLoggedIn", "true");
//                 setIsLoggedIn(true);
//               }}
//             />
//           }
//         />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/CalibrationLog" element={<CalibrationLog />} />
//         <Route path="/CalibrationLoglistPage" element={<CalibrationLoglistPage />} />
//         <Route path="/Assetregisterpagelist" element={<AssetregisterPageList />} /> 

        
//       </Routes>
//     </div>
//   );
// }

// export default App;



// import React, { useState } from "react";
// import { Routes, Route, useNavigate } from "react-router-dom";
// import LoginPage from "./page/login/LoginPage";
// import CalibrationLog from "./page/CalibrationLog/CalibrationLog";
// import CalibrationLoglistPage from "./page/CalibrationLog/CalibrationLoglist";
// import Dashboard from "./page/dashboard/Dashboard";
// import "./App.css";

// function App() {
//   const navigate = useNavigate();
//   const [menuOpen, setMenuOpen] = useState(false);

//   // ✅ Menu items defined as an array
//   const menuItems = [
//     { name: "Dashboard", path: "/dashboard" },
//     { name: "Calibration", path: "/CalibrationLoglistPage" },
//     { name: "Logout", path: "/" },
//   ];

//   const handleMenuClick = () => {
//     setMenuOpen((prev) => !prev);
//   };

//   const handleNavigate = (path) => {
//     setMenuOpen(false);
//     navigate(path);
//   };

//   return (
//     <div className="app-container">
//       {/* ✅ Hamburger Menu */}
//       <div className="menu-container">
//         <div className="menu-icon" onClick={handleMenuClick}>
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="43"
//             height="60"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="black"
//             strokeWidth="2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//           >
//             <line x1="4" y1="6" x2="20" y2="6" />
//             <line x1="4" y1="12" x2="20" y2="12" />
//             <line x1="4" y1="18" x2="20" y2="18" />
//           </svg>
//         </div>

//         {/* ✅ Dropdown Menu */}
//         {menuOpen && (
//           <div className="menu-dropdown">
//             {menuItems.map((item) => (
//               <button
//                 key={item.path}
//                 onClick={() => handleNavigate(item.path)}
//                 className="menu-item"
//               >
//                 {item.name}
//               </button>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* ✅ Routes */}
//       <Routes>
//         <Route path="/" element={<LoginPage />} />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/CalibrationLog" element={<CalibrationLog />} />
//         <Route path="/CalibrationLoglistPage" element={<CalibrationLoglistPage />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;




// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import LoginPage from "./page/login/LoginPage";
// import CalibrationLog from "./page/CalibrationLog/CalibrationLog";
// import CalibrationLoglistPage from "./page/CalibrationLog/CalibrationLoglist";
// import Dashboard from "./page/dashboard/Dashboard";


// function App() {
//   return (
//     <Routes>
//       <Route path="/" element={<LoginPage />} />
//       <Route path="/CalibrationLog" element={<CalibrationLog />} />
//       <Route path="/CalibrationLoglistPage" element={<CalibrationLoglistPage />} />
//       <Route path="/dashboard" element={<Dashboard />} />
//     </Routes>
//   );
// }

// export default App;





 